







































































import _ from 'lodash';

import { EditStoreMixin } from '@/main/pages/editStoreMixin';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { EditableStatus } from '@/main/components/constants';
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { Row } from '@/main/utils/table';
import { showAlert } from '@/main/utils/notifications';

import DmsEditableTable from '#components/dms/layout/EditableTable.vue';

import { PLANNED_ORDER_SERVICE_JOB, PLANNED_ORDER_SERVICE_JOB_COLS, PRACOVNI_POZICE, ND } from '../constants';

import { store } from '../store/edit';

import { apiProvider } from './api';
import { apiProvider as OZakazkaProvider } from '../api';
import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

export default EditStoreMixin.extend({
	name: 'PlannedOrderServiceJobTable',
	components: {
		DmsEditableTable,
	},
	data() {
		return {
			commentInput: '',
			plannedOrderServiceJobCols: PLANNED_ORDER_SERVICE_JOB_COLS,
			serviceJobId: 0 as number | null,
			serviceJobDescription: '',
			loading: true,
			canEdit: false,
			canEditComments: true,
			shouldDeleteRow: true,
		};
	},
	computed: {
		...genVuexComputeds(store),
		serviceJobName(): string {
			return PLANNED_ORDER_SERVICE_JOB;
		},
	},
	props: {
		storeUri: { type: String, default: null, required: true },

	},
	methods: {
		onCommentInput(event: any, row: Row, columnId: number) {
			this.commentInput = event;
			row.cells[columnId] = event;
		},
		updateRow(rowToUpdate: { tableName: string; updateStatus: EditableStatus; rowId: number; row: Row, rowIndex: number }) {
			if (rowToUpdate.updateStatus === EditableStatus.DELETED) {
				return;
			}
            this.$store.commit(`${this.storeUri}/updateTableRow`, rowToUpdate);
		},
		async onEditRow() {
			showAlert({
				message: this.LocalizeChyboveHlasky('CommentsCanOnlyEdit'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: {
					type: 'info',
				},
			});
			this.canEdit = false;
			this.canEditComments = true;
		},
		async createRow() {
			this.canEdit = true;
			this.canEditComments = true;
			(this.$refs.editableTable as any).createRow();
		},

		async refresh(tableName: string) {
			await this.fetchTableData([tableName]);
		},
		getServiceJob(row: Row, columnId: number) {
			const result: DropdownItem = this.dropdownList.ServiceJobs.find(
				(item: DropdownItem) => item.Value === parseInt(row.cells[columnId]),
			)!;
			return result?.Value;
		},
		async onServiceJobChange(selectedServiceJobId: string, columnId: number, updateCol: any, row: Row) {
			let serviceJobIdColId: number = this.dependentTables.PlannedOrderServiceJob.cellNames!.SERVICE_JOB_ID;
			let serviceJobDescriptionColId: number = this.dependentTables.PlannedOrderServiceJob.cellNames!.SERVICE_JOB_DESCRIPTION;
			updateCol(selectedServiceJobId, columnId);
			let result: any = this.dropdownList.ServiceJobs.find(
				(item: any) => item.Value === selectedServiceJobId,
			)!;
			updateCol(result?.Value, serviceJobIdColId);
			updateCol(result?.Text, serviceJobDescriptionColId);
			this.serviceJobId = result?.Value;
			this.serviceJobDescription = result?.Text;
		},
		async rowSaved({ row: newRow }: { row: Row }) {
			let serviceJobIdColId: number = this.dependentTables.PlannedOrderServiceJob.cellNames!.SERVICE_JOB_ID;
			const idColId: number = this.dependentTables.PlannedOrderServiceJob.cellNames!.ID;
			const rowId:number = newRow.cells[idColId];
			if (this.dependentTables.PlannedOrderServiceJob.rows.find(r => r.cells[serviceJobIdColId] === this.serviceJobId)) {
				if (rowId < 0) {
					showAlert({
						message: this.LocalizeChyboveHlasky('SJ_Already_Selected_Msg'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: {
							type: 'info',
						},
					});
					return;
				}
				return;
			}
			if (this.serviceJobId === 0) {
				return;
			}
			let serviceJobDescriptionColId: number = this.dependentTables.PlannedOrderServiceJob.cellNames!.SERVICE_JOB_DESCRIPTION;
			newRow.cells[serviceJobIdColId] = this.serviceJobId;
			newRow.cells[serviceJobDescriptionColId] = this.serviceJobDescription;
			this.dependentTables.PlannedOrderServiceJob.rows.push(newRow);
			console.log(newRow);
		},
		async deleteRow(item: any) {
			const confirmDelete = await this.showConfirm({
			message: this.LocalizeChyboveHlasky('SURE_TO_DELETE'),
			title: this.LocalizeChyboveHlasky('SURE_TO_DELETE_CONFIRM'),
			options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
			if (confirmDelete) {
				this.$store.commit(`${this.storeUri}/${START_LOADING}`);
				await OZakazkaProvider.deleteServiceJob(item.rowId)
				await this.fetchTableData([PLANNED_ORDER_SERVICE_JOB,PRACOVNI_POZICE,ND]);
				this.$store.commit(`${this.storeUri}/${END_LOADING}`);
			}
		}
	},
});
